import {FetchHandler} from "../../infrastructure/handlers/fetch-handler";
import {H2hDomainService} from "../../domain/h2h/services/h2h.domain-service";
import {H2hRequestParams} from "../../domain/h2h/models/h2h.request-params";
import {ACTION_TYPES, COMPONENT_STATES, FETCHING_STATES} from "../consts";
import {runInAction} from "mobx"
import type {H2hDataSource} from "../../domain/h2h/models/h2h.data-source";


export class H2hFetchHandler extends FetchHandler {
  static injectables = [H2hDomainService];

  onLoaded() {
    super.onLoaded();

    this.action()
  }

  get requestParams(): H2hRequestParams {
    const gameId: Number = this.controller.props.gameId;
    const matchupId: String = this.controller.props.matchupId;
    const topBookmaker: Number = this.state.appState.topBookmakerId;
    const showOdds: Boolean = this.controller.props.showOdds;
    const requestParams: H2hRequestParams = new H2hRequestParams(gameId, matchupId, topBookmaker, showOdds);

    return requestParams;
  }

  async action() {
    const dataSource: H2hDataSource = await this.fetch(this.createDomainParams(), true);

    await this.controller.action(ACTION_TYPES.populateData, {dataSource});
    this.controller.props.onWidgetVisible?.(this.state.isPopulated);
    this.store.setComponentState(COMPONENT_STATES.loaded);
    this.store.setFetchingState(FETCHING_STATES.idle);

    return dataSource;
  }

  onDidUpdate(prevProps, nextProps) {
    super.onDidUpdate(prevProps, nextProps);

    const showOddsChanged: Boolean = prevProps.showOdds !== nextProps.showOdds;
    if(showOddsChanged) {
      this.action();
    }
    runInAction(() => {
      this.state.shouldFilterByHomeAway = nextProps.shouldFilterByHomeAway;
    })

    if (nextProps.gameId !== prevProps.gameId) {
      this.action();
    }
  }
}
